import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Equivale à validação de sessão no início de cada rotina ADVPL
// Se o usuário não estiver logado, redireciona para o login automaticamente
function RotaProtegida({ children }) {
  const { isAutenticado } = useAuth();

  if (!isAutenticado) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default RotaProtegida;
